<script>
    // Licensed under Gnu Public Licence version 2
    // Copyright (c) 2023 (original work) Open Assessment Technologies SA ;

    import { createEventDispatcher } from 'svelte';
    import { Button } from '@oat-sa-private/ui-elements';
    import { __ } from '@oat-sa-private/ui-core';

    const dispatch = createEventDispatcher();
</script>

<style>
    .modalfeedback-nav {
        height: var(--nav-height, 9rem);
        @add-mixin flex-center-center;
    }
</style>

<div class="modalfeedback-nav">
    <Button shape="pill" size="small" label={__('Continue')} on:click={() => dispatch('modalFeedbackContinue')} />
</div>
